import { render, staticRenderFns } from "./FormTemplateStructure.vue?vue&type=template&id=09cdca8a&"
import script from "./FormTemplateStructure.vue?vue&type=script&lang=js&"
export * from "./FormTemplateStructure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports